import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { brandInfo } from '@/mocks/site'

interface CtaBandProps {
  eyebrow?: string
  title: string
  description: string
}

export default function CtaBand({ eyebrow, title, description }: CtaBandProps) {
  const { t } = useTranslation()
  const eyebrowText = eyebrow || t('cta.defaultEyebrow')

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="relative rounded-lg overflow-hidden bg-primary-950 px-6 py-12 md:px-14 md:py-16">
          <div className="absolute -top-24 -right-20 w-72 h-72 rounded-full bg-primary-800/40 blur-3xl" />
          <div className="absolute -bottom-24 -left-16 w-64 h-64 rounded-full bg-accent-900/25 blur-3xl" />

          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3 mb-4">
                <span className="h-px w-10 bg-primary-400" />
                <span className="section-label text-primary-300 text-[11px] md:text-xs font-medium">{eyebrowText}</span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-semibold text-background-50 leading-tight">
                {title}
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed">{description}</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href={brandInfo.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-whatsapp-line text-lg" />
                {t('common.whatsappUs')}
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md border border-background-50/30 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-mail-send-line text-lg" />
                {t('common.sendEnquiry')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}